module.exports = {
    // basic
    'request-access': 'solicitar acceso',
    'sign-in': 'iniciar sesión',
    'support': 'soporte',
    'alternate': 'alternativo',
    'copyright': 'derechos de autor',
    'forgot-your-password': '¿olvidaste tu contraseña?',
    'version': 'versión',
    'locked-out': '¿bloqueado?',
    'other-issues': '¿otros problemas?',
    'terms-and-conditions-header': 'términos de uso del sitio web',
    'schedule-a-demo': 'programe una demostración',
    'learn-more': 'clic aquí para saber más',
    'trouble-signing-in': '¿problemas para entrar?',
    'i-accept': 'acepto',
    'i-dont-accept': 'no acepto',
    'continue': 'seguir',
    'unsupported-browser': 'navegador no soportado',

    // raw
    'request-access-success': `
        <p>
            Su solicitud de acceso ha sido recibida.
        </p>
        <p>
            Operadores de WellDrive revisarán su solicitud y se comunicarán con usted una vez que haya sido aprobada.
        </p>
        <p>
            <a href="login.html" class="btn btn-primary">Regresar a la página de inicio de sesión</a>
        </p>
    `,
    'forgot-password-request-success': `
        <p>
            Si el nombre de usuario que especifió existe en nuestro sistema, hemos enviado un enlace de restablecimiento de contraseña a su correo electrónico.
        </p>
        <p>
            <a href="#login" class="forgot-password-link">Volver a la página de inicio de sesión</a>
        </p>
    `,
    'forgot-password-request-fail': `
        <p>
            No podemos completar su solicitud.
        </p>
        <p>
            Siga las instrucciones a continuación para <b>Los usuarios bloqueados</b>.
        </p>
    `,
    'bad-credentials': 'El nombre de usuario o contraseña son incorrectos.',
    'account-locked': 'Tu cuenta esta bloqueada. Llámenos 24/7 al (877) 704-8270 o envíenos un correo electrónico a ops@welldrive.com.',
    'account-lock-warning': 'El siguiente intento fallido de inicio de sesión dará como resultado el bloqueo de su cuenta.',
    'account-has-no-role': 'Su cuenta requiere más configuración.  Por favorcomuníquese con los Operadores de WellDrive para obtener ayuda.',
    'account-locked-inactive': `Su cuenta está bloqueada debido a la inactividad. Para desbloquear su cuenta, puede restablecer su contraseña haciendo clic en el enlace Olvidé Mi Contraseña, a continuación, o comuníquese con Operaciones de WellDrive para obtener ayuda.`,
    'login-header': 'Todos sus datos de pozo en un solo lugar.',
    'login-title': 'Iniciar sesión en WellDrive',
    'forgot-password-description': 'Ingrese su nombre de usuario y le enviaremos un correo electrónico con más instrucciones a la dirección de correo electrónico registrada para esa cuenta.',
    'login-body': 'WellDrive conecta a Operadores, Compañías de Servicio y Socios de una manera que ninguna otra solución tiene, para poner todos sus archivos de pozo a su alcance, para facilitar la búsqueda y el intercambio.',
    'login-tagline': 'Ahorre tiempo, dinero, esfuerzo - y el dolor de cabeza de encontrar y limpiar datos.',
    'apps-available': 'Disponible en iOS y Android.',
    'uploads': 'Subidas',
    'uptime': 'Tiempo de Actividad',
    'owners-and-operators': 'Propietarios y Operadores',
    'service-companies': 'Compañías de Servicio',
    'active-users': 'Usuarios Activos',
    'operations-support': 'Soporte de Operaciones',
    'sales-and-marketing': 'Ventas y Marketing',
    'locked-out-body1': `Si no ha iniciado sesión durante algún tiempo, es posible que su cuenta haya sido bloqueada debido a la inactividad. `,
    'locked-out-body2': `Llámenos 24/7 a <a href="tel:8777048270" class="forgot-password-link">(877) 704-8270</a> o envíenos un correo electrónico a`,
    'other-issues-body': `Intente volver a cargar la página web, usar un navegador diferente o borrar la memoria caché de su navegador. Si todavía tiene problemas, llámenos las 24 horas del día, los 7 días de la semana al <a href="tel:8777048270" class="forgot-password-link">(877) 704-8270</a> o envíenos un correo electrónico a`,
    'looking-for-more-info': '¿Busca más información sobre WellDrive?',
    'looking-for-more-info-body': `Haga clic aquí para obtener detalles sobre el conjunto de ofertas de WellDrive, las últimas noticias y más.`,
    'coming-soon': '¡Próximamente!',
    'new-user': '¿Nuevo usuario de WellDrive?',
    'new-user-body': `Solicite acceso enviando el formulario a continuación, llámenos las 24 horas del día, los 7 días de la semana al <a href="tel:8777048270" class="forgot-password-link">(877) 704-8270</a> o envíenos un correo electrónico a`,
    'terms-and-conditions': 'Términos y Condiciones',
    'browser-not-supported-1': `
        <p>
            WellDrive no admite oficialmente el navegador que está utilizando.
        </p>
        <p>
            Para aprovechar al máximo WellDrive, utilice la última versión de uno de los siguientes navegadores compatibles oficialmente:
        </p>
    `,
    'browser-not-supported-2': `
        <p>
            Puede hacer clic en el botón a continuación para continuar con el sitio utilizando su navegador actual, pero es posible que algunas funciones no funcionen según lo previsto y que experimente un rendimiento deficiente.
        </p>
        <p>
            Si cree que recibió este mensaje por error o tiene alguna pregunta, siempre estamos aquí para ayudarlo. Envíenos un correo electrónico a <a href="mailto:ops@welldrive.com">ops@welldrive.com</a> o llámenos al <a
            href="tel:18777048270">1-877-704-8270</a>.
        </p>
    `,
    'chrome-download-tooltip': 'Haga clic para descargar.',
    'firefox-download-tooltip': 'Haga clic para descargar.',
    'edge-download-tooltip': 'Microsoft Edge ya está instalado en Windows 10. También se puede instalar en Windows 7, 8 y 8.1.',
    'safari-download-tooltip': 'Safari es el navegador predeterminado en Apple Mac OSX e iOS. Solo está disponible en los sistemas operativos de Apple.',
    'sso-required': `
        Esta cuenta es necesaria para iniciar sesión mediante Single Sign On (SSO).<br />
        Visite <a href="https://enterprise.welldrive.com" target="_blank">https://enterprise.welldrive.com</a> e inicie sesión con las credenciales de su empresa.
    `,

    // template
};
